import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { CompactSign } from '../jws/compact/sign.js';
import { JWTInvalid } from '../util/errors.js';
import { encoder } from '../lib/buffer_utils.js';
import { ProduceJWT } from './produce.js';
export var SignJWT =
/*#__PURE__*/
function (_ProduceJWT) {
  _inherits(SignJWT, _ProduceJWT);

  function SignJWT() {
    _classCallCheck(this, SignJWT);

    return _possibleConstructorReturn(this, _getPrototypeOf(SignJWT).apply(this, arguments));
  }

  _createClass(SignJWT, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(key, options) {
        var _a, sig;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sig = new CompactSign(encoder.encode(JSON.stringify(this._payload)));
                sig.setProtectedHeader(this._protectedHeader);

                if (!(Array.isArray((_a = this._protectedHeader) === null || _a === void 0 ? void 0 : _a.crit) && this._protectedHeader.crit.includes('b64') && this._protectedHeader.b64 === false)) {
                  _context.next = 4;
                  break;
                }

                throw new JWTInvalid('JWTs MUST NOT use unencoded payload');

              case 4:
                return _context.abrupt("return", sig.sign(key, options));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return SignJWT;
}(ProduceJWT);